import {Injectable} from '@angular/core'
import {Backend} from "@generated-backend-types";
import {BaseEndpointService} from '../base-endpoint-service';
import {ListItem} from '../../../entities/list-item.entity';
import Email = Backend.App.Resources.Dashboard.Administration.Email;
import EmailData = Backend.App.Data.Dashboard.Administration.EmailData;
import {Observable, take} from 'rxjs';
import EmailPreviewData = Backend.App.Data.Dashboard.Administration.EmailPreviewData;
import PatientEmailData = Backend.App.Data.Dashboard.Administration.PatientEmailData;

@Injectable({providedIn: 'root'})
export class EmailService extends BaseEndpointService<Email, EmailData> {
  public override readonly multiSelectSortBy = 'title';
  protected override endpoint = '/administration/emails';

  public preview(emailId: string, emailPreviewData: EmailPreviewData): Observable<string> {
    return this.http.post(this.endpoint + `/${emailId}/preview`, emailPreviewData, {responseType: 'text'})
      .pipe(take(1));
  }

  public sendPatientEmail(patientId: string, emailData: PatientEmailData): Observable<void> {
    return this.http.post<void>(`/patients/${patientId}/email`, emailData);
  }

  public override modelToMultiSelectItem(m: Email): ListItem & { model: Email } {
    return {
      id: m.id,
      text: m.title,
      isDisabled: false,
      model: m,
    }
  }
}
